import enLang from "./entries/en-US";
import esLang from "./entries/es-FR";

const AppLocale = {
  en: enLang,
  fr: esLang
};

export default AppLocale;
